"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactGridLayout = require("react-grid-layout");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _moment = _interopRequireDefault(require("moment"));

var _Stepper = _interopRequireDefault(require("@material-ui/core/Stepper"));

var _Step = _interopRequireDefault(require("@material-ui/core/Step"));

var _StepLabel = _interopRequireDefault(require("@material-ui/core/StepLabel"));

var _useAsyncEffect = require("use-async-effect2");

var _reactStepWizard = _interopRequireDefault(require("react-step-wizard"));

var _usePostRequest3 = _interopRequireDefault(require("../hooks/usePostRequest"));

var _usePutRequest3 = _interopRequireDefault(require("../hooks/usePutRequest"));

var _Wizard = _interopRequireDefault(require("./dynamic-form/inputs/Wizard"));

var _DynamicField = _interopRequireDefault(require("./DynamicField"));

var _Notification = _interopRequireDefault(require("./Notification"));

var _urls = require("../utils/urls");

var _utils = _interopRequireDefault(require("../utils/utils"));

var _services = _interopRequireDefault(require("../services"));

require("react-grid-layout/css/styles.css");

require("react-resizable/css/styles.css");

var _ResponsiveGridLayout = _interopRequireDefault(require("./ResponsiveGridLayout"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

//const ResponsiveGridLayout = WidthProvider(Responsive);
var Segment = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 1em 0.1em;\n"])));

var ElementContainer = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  & {\n    height: 100%;\n  }\n\n  &.centered .field {\n    height: 100%;\n    display: flex;\n    width: 100%;\n    align-items: center;\n  }\n"]))); // elementos del formulario


var itemForm = function itemForm(field, handleChangeInput, editMode, detail, isValid, previewMode, readOnly, formId, zPosition, loading, loadingSelect, handleElements, btnDisabled, titleLabel, gridSize) {
  var getItemPosition = function getItemPosition(position) {
    var initialPosition = "x".concat(position.x, "y").concat(position.y);
    var finalColPosition = "x".concat(position.x + (position.w - 1), "y").concat(position.y);
    var finalRowPosition = "x".concat(position.x, "y").concat(position.y + (position.h - 1));
    return "".concat(initialPosition, " / ").concat(initialPosition, " / ").concat(finalRowPosition, " / ").concat(finalColPosition);
  };

  return /*#__PURE__*/React.createElement("div", {
    key: field.uid,
    "data-grid": field.layout,
    style: {
      zIndex: zPosition,
      gridArea: getItemPosition(field.layout)
    },
    className: field.elementType === "radio" && "initial"
  }, /*#__PURE__*/React.createElement(ElementContainer, {
    className: "".concat(field.elementType === "checkbox" ? "centered" : ""),
    style: field.elementType === "label" ? {
      display: "flex",
      alignItems: field.alignItems,
      justifyContent: field.justifyContent
    } : {}
  }, /*#__PURE__*/React.createElement(_DynamicField.default, {
    field: field,
    handleChangeInput: handleChangeInput,
    editMode: editMode,
    detail: detail,
    isValid: isValid,
    previewMode: previewMode,
    readOnly: readOnly,
    formId: formId,
    loading: loading,
    loadingSelect: loadingSelect,
    handleElements: handleElements,
    btnDisabled: btnDisabled,
    titleLabel: titleLabel,
    gridSize: gridSize
  })));
}; // TODO: props.isDataSaved si es true o existe es PUT de lo contrario es POST


var DynamicForm = function DynamicForm(props) {
  console.log("DynamicForm props: ", JSON.stringify(props));

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      setFormData = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      definitions = _useState4[0],
      setDefinitions = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      loadingSelect = _useState6[0],
      setLoadingSelect = _useState6[1];

  var _useState7 = (0, _react.useState)({
    open: false,
    type: "success",
    msg: ""
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      openAlert = _useState8[0],
      setOpenAlert = _useState8[1];

  var _usePostRequest = (0, _usePostRequest3.default)(null, props.token),
      _usePostRequest2 = _slicedToArray(_usePostRequest, 2),
      loadingSave = _usePostRequest2[0].loading,
      saveData = _usePostRequest2[1];

  var _usePutRequest = (0, _usePutRequest3.default)(null, props.token),
      _usePutRequest2 = _slicedToArray(_usePutRequest, 2),
      loadingUpdate = _usePutRequest2[0].loading,
      updateData = _usePutRequest2[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = _slicedToArray(_useState9, 2),
      elements = _useState10[0],
      setElements = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      btnDisabled = _useState12[0],
      setBtnDisabled = _useState12[1];

  var _useState13 = (0, _react.useState)(0),
      _useState14 = _slicedToArray(_useState13, 2),
      activeStep = _useState14[0],
      setActiveStep = _useState14[1];

  var _useState15 = (0, _react.useState)({}),
      _useState16 = _slicedToArray(_useState15, 2),
      dataAdvance = _useState16[0],
      setDataAdvance = _useState16[1];

  var _useState17 = (0, _react.useState)(null),
      _useState18 = _slicedToArray(_useState17, 2),
      index = _useState18[0],
      setIndex = _useState18[1];

  var isDesktop = _utils.default.isDesktop();

  var handleDataAdvance = function handleDataAdvance(data) {
    setDataAdvance(_objectSpread(_objectSpread({}, dataAdvance), {}, _defineProperty({}, index, data)));
  };

  var handleResetForm = function handleResetForm() {
    var tmp = definitions.map(function (res) {
      res.value = "";
      return res;
    });
    setDefinitions(tmp);
  };

  var handleNext = function handleNext() {
    return setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
  };

  var handleBack = function handleBack(crr) {
    return setActiveStep(crr);
  }; // asynchronous routines in React components


  var textWatcher = (0, _useAsyncEffect.useAsyncWatcher)(elements);
  (0, _react.useEffect)(function () {
    var _props$definition;

    var arrAccordions = (_props$definition = props.definition) === null || _props$definition === void 0 ? void 0 : _props$definition.filter(function (res) {
      return res.elementType === "accordion";
    });
    var tmp = props.definition; // introduce children to accordions

    if (arrAccordions !== null && arrAccordions !== void 0 && arrAccordions.length) {
      var newAccordions = arrAccordions.map(function (accordion) {
        props.definition.forEach(function (el) {
          el.inside = false;
          if (el.childAccordion === accordion.uid) accordion.childs.push(el);
        });
        return accordion;
      });
      tmp = props.definition.map(function (obj) {
        return newAccordions.find(function (o) {
          return o.uid === obj.uid;
        }) || obj;
      });
    }

    setDefinitions(tmp);
  }, [props.definition]);
  var serverInfo = (0, _react.useMemo)(function () {
    var el = definitions === null || definitions === void 0 ? void 0 : definitions.find(function (f) {
      return f.elementType === "button";
    });
    return el === null || el === void 0 ? void 0 : el.source.parameters;
  }, [definitions]); // establecer formData

  (0, _react.useEffect)(function () {
    var _data$find;

    var data = props.definition;
    setFormData(mapData(data));
    var infoServer = data === null || data === void 0 ? void 0 : (_data$find = data.find(function (f) {
      return f.elementType === "button";
    })) === null || _data$find === void 0 ? void 0 : _data$find.source.parameters;

    if (props.typeForm === "simple" && !infoServer || (infoServer === null || infoServer === void 0 ? void 0 : infoServer.server) === "" && (infoServer === null || infoServer === void 0 ? void 0 : infoServer.service.url) === "" && (infoServer === null || infoServer === void 0 ? void 0 : infoServer.service.name) === "") {
      setOpenAlert({
        open: true,
        type: "warning",
        msg: "Falta agregar o completar la información del servidor (endpoint)"
      });
    }
  }, [props.definition, props.typeForm]);

  var find = function find(fieldId) {
    if (!fieldId) {
      return undefined;
    }

    var f = definitions === null || definitions === void 0 ? void 0 : definitions.find(function (x) {
      return x.uid === fieldId;
    });
    return f;
  };

  var isValidCustomValidation = function isValidCustomValidation(field, value) {
    var validation = new RegExp(field.customValidation, "i");
    var result = validation.test(value);
    return result;
  };

  var isValid = (0, _react.useCallback)(function () {
    if (!activeStep || activeStep > 0) {
      var filteredFields = [];

      if ((definitions === null || definitions === void 0 ? void 0 : definitions.length) > 0) {
        filteredFields = definitions === null || definitions === void 0 ? void 0 : definitions.map(function (f) {
          var age = null;
          if (f.elementType === "date") age = (0, _moment.default)().diff(f.value, "years");

          if (f.elementType === "radio" && f.required && f.value === "default" || f.elementType === "checkbox" && f.required && (f.value === "default" || !_utils.default.existSomeCheckboxInTrue(f.elementType === "checkbox" ? f.attributes : [])) || !f.allowNull && f.value === "" && f.elementType !== "checkbox" || !f.allowNull && f.value === "+" && f.elementType !== "checkbox" || f.elementType === "date" && !f.allowNull && f.value === null || f.elementType === "date" && f.isBirthday && age < 18 || f.customValidation && !isValidCustomValidation(f, f.value)) {
            if ("step-".concat(activeStep + 1) === f.childAccordion || !f.childAccordion && f.elementType !== "accordion" ||
            /* !props.isAdvance || */
            props.isAdvance === undefined || // eslint-disable-next-line eqeqeq
            props.isAdvance == "undefined" || // eslint-disable-next-line eqeqeq
            activeStep == "undefined") {
              f.hasError = true;
            } else {
              f.hasError = false;
            }
          } else {
            f.hasError = false;
          }

          return f;
        });
      }

      setDefinitions(filteredFields);
      return filteredFields.some(function (f) {
        return f.hasError;
      });
    }
  }, [activeStep, definitions, props.isAdvance]);

  var handleElements = function handleElements(data) {
    return setElements(data);
  };

  var saveAnswers = function saveAnswers(fieldId, value) {
    //Esto almacena todas las respuestas de modo tal de tener una lista de las respuestas y poder verificar al momento del summit o de la visualizacion del componente y tomar accion en base a la propiedad disableDependency alamcenada en el componente de la BD, asi corroborar que componente depende de otro
    var storedAnswers = JSON.parse(localStorage.getItem("storedAnswers")) || [];
    var disableDependencyFound = storedAnswers.find(function (item) {
      return item.fieldId === fieldId;
    });

    if (disableDependencyFound) {
      //delete the previous value
      var _index = storedAnswers.findIndex(function (item) {
        return item.fieldId === fieldId;
      });

      storedAnswers.splice(_index, 1);
    } //insert the new value


    var newValue = {
      fieldId: fieldId,
      value: value
    };
    storedAnswers.push(newValue);
    localStorage.setItem("storedAnswers", JSON.stringify(storedAnswers));
  };

  var handleChange = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(fieldId, value) {
      var inputType,
          name,
          label,
          watcher,
          uniqueData,
          selects,
          lastElement,
          tmp,
          thisField,
          _args2 = arguments;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              inputType = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : null;
              name = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : null;
              label = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : null;
              saveAnswers(fieldId, value); // eslint-disable-next-line default-case

              _context2.t0 = inputType;
              _context2.next = _context2.t0 === "select" ? 7 : _context2.t0 === "checkbox" ? 23 : 26;
              break;

            case 7:
              setLoadingSelect(_defineProperty({}, name, true));
              _context2.next = 10;
              return textWatcher();

            case 10:
              watcher = _context2.sent;
              uniqueData = _toConsumableArray(watcher.reduce(function (map, obj) {
                return map.set(obj.name, obj);
              }, new Map()).values());
              selects = definitions === null || definitions === void 0 ? void 0 : definitions.filter(function (f) {
                return f.elementType === "select";
              });
              lastElement = selects[selects.length - 2];
              console.log("selector depend value: ", value);
              console.log("selector depend name: ", name);
              _context2.t1 = setDefinitions;
              _context2.next = 19;
              return Promise.all(definitions === null || definitions === void 0 ? void 0 : definitions.map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(def) {
                  var lastElementUnq, unqArr, path, response;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(def.elementType === "select" && def.dependencies.some(function (dep) {
                            return dep === name;
                          }))) {
                            _context.next = 15;
                            break;
                          }

                          if (uniqueData.length >= selects.length) {
                            uniqueData.length = def.dependencies.length;
                          }

                          lastElementUnq = uniqueData[uniqueData.length - 1]; //todo: verificar esto y hacer refactor (codigo viejo de enmanuel)

                          /* if (
                            def.dependencies.length === uniqueData.length ||
                            lastElement.name === lastElementUnq.name
                          ) */

                          if (!true) {
                            _context.next = 13;
                            break;
                          }

                          unqArr = uniqueData.map(function (unq) {
                            return unq.value;
                          }); // penultimate element

                          /* if (
                             selects.length > 3 &&
                             lastElement.name === lastElementUnq.name
                           ) {
                             unqArr.splice(unqArr.length - 2, 1);
                           }  */

                          unqArr.length = def.dependencies.length; //const path = unqArr.reverse().join("/");
                          //const path = currentSelector ? currentSelector.value : unqArr.reverse().join("/");
                          //const currentSelector = uniqueData.find(item=>item.name === name)

                          path = value;
                          _context.next = 9;
                          return (0, _services.default)("".concat(def.source.parameters.url).concat(path));

                        case 9:
                          response = _context.sent;

                          // show msg
                          if (!response.length) {
                            setOpenAlert({
                              open: true,
                              type: "warning",
                              msg: "".concat(label, " no tiene informaci\xF3n, por favor seleccione otra opci\xF3n")
                            });
                          } // data defaultValues

                          /*  const result = response.map((d) => ({
                             value: d._id,
                             label: d.name,
                           })); */


                          console.log("selector depend response: ", response); //def.source.defaultValues = result;

                          def.source.defaultValues = response;

                        case 13:
                          // set value next dependencies
                          def.value = "";
                          return _context.abrupt("return", def);

                        case 15:
                          return _context.abrupt("return", def);

                        case 16:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 19:
              _context2.t2 = _context2.sent;
              (0, _context2.t1)(_context2.t2);
              setLoadingSelect(_defineProperty({}, name, false));
              return _context2.abrupt("break", 26);

            case 23:
              tmp = definitions === null || definitions === void 0 ? void 0 : definitions.map(function (r) {
                if (r.uid === fieldId) {
                  r.attributes = value;
                }

                return r;
              });
              setDefinitions(tmp);
              return _context2.abrupt("break", 26);

            case 26:
              //if (inputType !== "checkbox") {
              thisField = find(fieldId);
              thisField.value = value; //}

              setFormData(mapData(definitions));

            case 29:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var layout = definitions === null || definitions === void 0 ? void 0 : definitions.map(function (def) {
    var l = def.layout;
    l.i = def.uid;
    return l;
  });
  var definitionSize = (definitions === null || definitions === void 0 ? void 0 : definitions.length) + 1;

  var handleCloseAlert = function handleCloseAlert(e, reason) {
    if (reason === "clickaway") {
      return;
    }

    setOpenAlert(_objectSpread(_objectSpread({}, openAlert), {}, {
      open: false
    }));
  };

  var method = (0, _react.useCallback)(function (data, url) {
    return props.isDataSaved && props.quotationId || props.isDataSaved && props.paramToSave ? updateData(data, url) : saveData(data, url);
  }, [props.isDataSaved, props.paramToSave, props.quotationId, saveData, updateData]);
  var handleSubmit = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
      var URL_SERVER, newFormData, obj, idParam;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              e.preventDefault();
              _context3.prev = 1;
              URL_SERVER = !serverInfo ? "".concat(_urls.API_URL, "/form-builder/form-saved-data") : "".concat((serverInfo === null || serverInfo === void 0 ? void 0 : serverInfo.server) || _urls.API_URL, "/").concat((serverInfo === null || serverInfo === void 0 ? void 0 : serverInfo.service.url) || "form-builder", "/").concat((serverInfo === null || serverInfo === void 0 ? void 0 : serverInfo.service.name) || "form-saved-data");
              newFormData = mapData(definitions);

              if (newFormData.length) {
                _context3.next = 7;
                break;
              }

              setOpenAlert({
                open: true,
                type: "info",
                msg: "El formulario no tiene campos"
              });
              return _context3.abrupt("return");

            case 7:
              if (!((!props.isAdvance || props.isAdvance === "undefined") && isValid())) {
                _context3.next = 10;
                break;
              }

              // eslint-disable-next-line no-console
              console.error("There is an error saving the form");
              return _context3.abrupt("return");

            case 10:
              obj = {
                data: props.isAdvance ? dataAdvance : newFormData
              }; // return data

              if (props.onDataReturn) props.onDataReturn(obj); // added param from props component

              if (props.paramToSave) {
                obj.paramToSave = props.paramToSave;
              }

              idParam = props.paramToSave ? props.paramToSave : props.quotationId;
              _context3.next = 16;
              return method(obj, props.isDataSaved && props.quotationId || props.isDataSaved && props.paramToSave ? "".concat(URL_SERVER, "/").concat(idParam) // update
              : URL_SERVER // create
              );

            case 16:
              // disabled btn to save form
              setBtnDisabled(true);
              setOpenAlert({
                open: true,
                type: "success",
                msg: "Datos ".concat(props.isDataSaved && props.quotationId || props.isDataSaved && props.paramToSave ? "actualizados" : "guardados", " exitosamente")
              }); // redirect prop

              if (props.redirect) {
                setTimeout(function () {
                  props.redirect();
                }, 1000);
              } // enabled btn form


              setTimeout(function () {
                setBtnDisabled(false);
              }, 10000);
              _context3.next = 26;
              break;

            case 22:
              _context3.prev = 22;
              _context3.t0 = _context3["catch"](1);
              setBtnDisabled(false);
              setOpenAlert({
                open: true,
                type: "error",
                msg: "Ocurrio un error, por favor intente mas tarde"
              });

            case 26:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 22]]);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }(), [serverInfo, definitions, isValid, props, method, dataAdvance]);
  var gridSize = (0, _react.useMemo)(function () {
    return Number(props.gridSize);
  }, [props.gridSize]);
  var sortedDefinition = (0, _react.useMemo)(function () {
    return definitions === null || definitions === void 0 ? void 0 : definitions.filter(function (field) {
      return props.inside ? field.childAccordion : !field.childAccordion;
    }).sort(function (a, b) {
      return a.layout.x - b.layout.x;
    }).sort(function (a, b) {
      return a.layout.y - b.layout.y;
    });
  }, [definitions, props.inside]);

  var setNewVerticalPosition = function setNewVerticalPosition(node, verticalPosition) {
    var horizontalPosition = getPosition(node, "horizontal");
    node.style.webkitTransform = "translate(".concat(horizontalPosition, "px, ").concat(verticalPosition, "px)");
  };

  var getNodePositions = function getNodePositions(node) {
    return node.style.getPropertyValue("transform").match(/(-?[0-9\.]+)/g);
  };

  var getRealNodeHeight = function getRealNodeHeight(node) {
    return parseInt(node.scrollHeight);
  }; //get height including overflow


  var getAboveNode = function getAboveNode(nodes, targetNode) {
    var targetNodePositionX = getPosition(targetNode, "horizontal");
    var targetNodePositionY = getPosition(targetNode, "vertical");
    var aboveNode = null;
    var diffAxisYPositions = 10000000;

    if (nodes && nodes.length) {
      nodes.map(function (node) {
        var currentNodePositionX = node.positionX;
        var currentNodePositionY = node.positionY;

        if (currentNodePositionX === targetNodePositionX && currentNodePositionY < targetNodePositionY && diffAxisYPositions > targetNodePositionY - currentNodePositionY) {
          diffAxisYPositions = targetNodePositionY - currentNodePositionY;
          aboveNode = node;
        }
      });
    }

    return aboveNode;
  };

  var isOverflowThisNode = function isOverflowThisNode(topNode, bottomNode) {
    var result = false;
    var updatedNode = topNode.node;
    var topNodeHeight = getRealNodeHeight(updatedNode);
    var topNodePositionY = getPosition(updatedNode, "vertical");
    var topEndingVerticalPosition = topNodePositionY + topNodeHeight;
    var bottomNodePositionY = getPosition(bottomNode, "vertical");

    if (topEndingVerticalPosition > bottomNodePositionY) {
      result = true;
    }

    return result;
  };

  var getPosition = function getPosition(node, orientation) {
    var orientationTable = {
      "horizontal": 0,
      "vertical": 1
    };
    var nodePositions = getNodePositions(node);

    if (!nodePositions) {
      return undefined;
    }

    var resultPosition = nodePositions[orientationTable[orientation]];
    return parseInt(resultPosition);
  };

  var getNewVerticalPosition = function getNewVerticalPosition(topNode) {
    var updatedNode = topNode.node;
    var marginTop = 15;
    var topNodePositionY = getPosition(updatedNode, "vertical");
    var topNodeHeight = getRealNodeHeight(updatedNode);
    var newPositionY = topNodePositionY + topNodeHeight + marginTop;
    return newPositionY;
  };

  var recalculateVerticalPositions = function recalculateVerticalPositions() {
    /* esto es para recalcular las posiciones en vertical que el paquete react-grid-layout 
    no es capas de hacer cuando los componentes tienen overflow. esto puede causar q se 
    solapen componentes inferiores */
    //feature set new position for avoid overload content
    var reactGridItemNodes = document.querySelectorAll(".react-grid-item");

    if (reactGridItemNodes && reactGridItemNodes.length) {
      var copyNodes = [];
      reactGridItemNodes.forEach(function (node) {
        copyNodes.push({
          positionX: getPosition(node, "horizontal"),
          positionY: getPosition(node, "vertical"),
          height: getRealNodeHeight(node),
          node: node
        });
      });
      reactGridItemNodes.forEach(function (node) {
        var aboveNode = getAboveNode(copyNodes, node);
        node.classList.remove("initial");
        node.style.setProperty("height", "auto");

        if (aboveNode && isOverflowThisNode(aboveNode, node)) {
          var newVerticalPosition = getNewVerticalPosition(aboveNode);
          setNewVerticalPosition(node, newVerticalPosition);
        }
      });
    }
  };

  var blockAllElements = function blockAllElements() {
    //esta opcion se habilitara para el responsive tambien
    //esta opcion estara disponible si se activa un selector en la Edision llamada position: Block (uno encima del otro),relative(este tiene los traslate modificados para que no sean solapados por el tamaño de los de arriba),original (los traslate no modificados)
    //remove default styles from react-grid-layout, this is necesary for correct responsive specialy for the property transform
    var elements2 = document.querySelectorAll(".react-grid-item");

    if (elements2 && elements2.length) {
      elements2.forEach(function (node) {
        node.style.removeProperty("transform");
        node.style.removeProperty("height");
        node.style.setProperty("margin-bottom", "4vh");
        node.style.setProperty("position", "relative");
        node.classList.remove("initial");
      });
    }
  }; // remove styles by default react-grid-layout


  (0, _react.useEffect)(function () {
    /* const elements = document.querySelector(".react-grid-layout");
      if (
      props.typeForm !== "multiple" &&
      elements.childNodes.length &&
      definitions?.some((def) => def.elementType === "accordion")
    ) {
      elements.childNodes.forEach((element) => {
        element.style.removeProperty("position");
        element.style.removeProperty("height");
      });
    }
      //todo: mover estas funciones a un helper
    if(isDesktop){
      recalculateVerticalPositions()
    }else{
      blockAllElements()
    } */
  }, [definitions, props.typeForm]);

  var renderSteps = function renderSteps() {
    return sortedDefinition.filter(function (el) {
      return el.elementType === "accordion";
    }).map(function (field) {
      return /*#__PURE__*/React.createElement(_Wizard.default, {
        key: field.label,
        field: field,
        totalSteps: sortedDefinition.length,
        activeStep: activeStep,
        handleBack: handleBack,
        handleNext: handleNext,
        isValid: isValid,
        isValidCustomValidation: isValidCustomValidation,
        isAdvance: props.isAdvance,
        advanceCount: props.advanceCount,
        sortedDefinition: sortedDefinition,
        setActiveStep: setActiveStep,
        dataAdvance: dataAdvance,
        handleDataAdvance: handleDataAdvance,
        setIndex: setIndex,
        handleResetForm: handleResetForm,
        redirect: props.redirect
      });
    });
  };

  return /*#__PURE__*/React.createElement(Segment, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("form", {
    autoComplete: "off",
    onSubmit: handleSubmit,
    method: serverInfo === null || serverInfo === void 0 ? void 0 : serverInfo.operation
  }, props.typeForm === "multiple" ? /*#__PURE__*/React.createElement(_reactStepWizard.default, {
    nav: /*#__PURE__*/React.createElement(Nav, {
      setActiveStep: setActiveStep,
      activeStep: activeStep
    })
  }, renderSteps()) : /*#__PURE__*/React.createElement(_ResponsiveGridLayout.default, {
    gridSize: gridSize,
    definition: definitions
  }, sortedDefinition === null || sortedDefinition === void 0 ? void 0 : sortedDefinition.map(function (field) {
    definitionSize--;
    return itemForm(field, handleChange, props.editMode, props.detail, isValid, props.previewMode, props.readOnly, props.formId, definitionSize, loadingSave || loadingUpdate, loadingSelect, handleElements, btnDisabled, props.titleLabel, gridSize);
  }))), !props.inside && /*#__PURE__*/React.createElement(_Notification.default, {
    openAlert: openAlert.open,
    onCloseAlert: handleCloseAlert,
    message: openAlert.msg,
    type: openAlert.type
  }));
};

var mapData = function mapData(data) {
  return data === null || data === void 0 ? void 0 : data.filter(function (f) {
    return f.elementType !== "button" && f.elementType !== "label" && f.elementType !== "accordion";
  }).map(function (def) {
    var dataCheckbox = [];

    if (def.elementType === "checkbox") {
      dataCheckbox = def.attributes.map(function (d) {
        return d.value;
      });
    }

    return _defineProperty({}, def.name, def.elementType === "checkbox" ? dataCheckbox : def.value);
  });
}; // component nav styles wizard


var Nav = function Nav(props) {
  var navs = [];

  var _loop = function _loop(i) {
    navs.push( /*#__PURE__*/React.createElement(_Step.default, {
      key: "step-".concat(i),
      onClick: function onClick() {
        props.setActiveStep(i - 1);
        props.goToStep(i);
      }
    }, /*#__PURE__*/React.createElement(_StepLabel.default, null)));
  };

  for (var i = 1; i <= props.totalSteps; i += 1) {
    _loop(i);
  }

  return /*#__PURE__*/React.createElement(_Stepper.default, {
    alternativeLabel: true,
    activeStep: props.activeStep,
    style: {
      padding: 0,
      backgroundColor: "transparent"
    }
  }, navs);
};

var _default = DynamicForm;
exports.default = _default;